// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Jg8o","content":"styles_content__1qFsx","tableWrap":"styles_tableWrap__3tiEB"};